import { render, staticRenderFns } from "./EntriesTable.vue?vue&type=template&id=1c60aa61&scoped=true&"
import script from "./EntriesTable.vue?vue&type=script&lang=js&"
export * from "./EntriesTable.vue?vue&type=script&lang=js&"
import style0 from "./EntriesTable.vue?vue&type=style&index=0&id=1c60aa61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60aa61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c60aa61')) {
      api.createRecord('1c60aa61', component.options)
    } else {
      api.reload('1c60aa61', component.options)
    }
    module.hot.accept("./EntriesTable.vue?vue&type=template&id=1c60aa61&scoped=true&", function () {
      api.rerender('1c60aa61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/entries/EntriesTable.vue"
export default component.exports